export const setPage = (page, resource) => ({
  type: `${resource.toUpperCase()}_SET_PAGE`,
  page
});

export const setPageSize = (payload, resource) => ({
  type: `${resource.toUpperCase()}_SET_PAGE_SIZE`,
  payload,
});
